import { render, staticRenderFns } from "./viewDept.vue?vue&type=template&id=52966c0d&"
import script from "./viewDept.vue?vue&type=script&lang=js&"
export * from "./viewDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports